module.exports = __webpack_public_path__ + "img/dh3.28f81166.png";